import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import { Button, Confirm } from "semantic-ui-react";
import Swal from "sweetalert2";

const DeleteTemple = ({ id, reload}) => {
  const [open, setOpen] = useState(false);
  const onCompleted = async () => {
    await reload();
    Swal.fire({
      icon: 'success',
      title: 'Completado',
      text: 'Se ha eliminado la plantilla de manera exitosa.'
    }).then(() => setOpen(false))
  }
  const onError = ({ graphQLErrors }) => {
    if (graphQLErrors) {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: graphQLErrors[0]?.message
      });
    } else {
      Swal.fire("Lo sentimos, ha ocurrido un error.");
    }
  };
  const [mutation] = useMutation(DELETE_TEMPLE, { onCompleted, onError });
  const handleMutation = () => {
    mutation({ variables: { id } });
  }
  return (
    <div>
      <Button 
        style={{ backgroundColor: "#045A73", color: "white" }}
        size="mini"
        content="Eliminar" 
        icon="delete" 
        onClick={() => setOpen(true)} 
        />
      <Confirm
        size="tiny"
        confirmButton="Aceptar"
        cancelButton="Cancelar"
        open={open}
        content='Desea eliminar esta plantilla?'
        onCancel={() => setOpen(false)}
        onConfirm={handleMutation}
      />
    </div>
  );
};

const DELETE_TEMPLE = gql`
  mutation deleteTemple($id: ID!) {
    eliminarMultiPlantilla(id: $id)
  }
`;
export default DeleteTemple;